// This is necessary for the POL Switch company feature
// https://confluence.target.com/pages/viewpage.action?spaceKey=BPT&title=POL%20Logoff%20and%20Switch%20Company%20Logic%20for%20React%20based%20applications
// https://wiki.target.com/tgtwiki/index.php/Adding_an_Application_or_Report_to_POL

import { useAuth } from '@praxis/component-auth'
import Cookies from 'js-cookie'
import { ReactNode, useCallback, useEffect } from 'react'

export const isPol = window.location.hostname.includes('partnersonline')

interface POLAccountSwitcherProps {
  children: ReactNode
}

export const POLAccountSwitcher = ({ children }: POLAccountSwitcherProps) => {
  const { session } = useAuth()

  const clearLocalStorage = () => {
    window.localStorage.removeItem('access_token')
    window.localStorage.removeItem('id_token')
    Cookies.remove('SSOSESSIONINFO')
    Cookies.remove('id2Token')
  }

  const loggedInUserLanId = session?.userInfo?.lanId
  const checkCookie = useCallback(() => {
    const sessionJson = getCookieSessionJson(Cookies.get('SSOSESSIONINFO'))

    if (sessionJson && !sessionJson?.login_status) {
      // the session is logged out! Clear everything and relog!
      clearLocalStorage()
      window.location.reload()
    }
    if (loggedInUserLanId !== undefined && sessionJson?.user !== undefined) {
      // verify the user is the same one from cookie set by assent!
      if (loggedInUserLanId !== String(sessionJson?.user)) {
        clearLocalStorage()
        window.location.reload()
      }
    }
  }, [loggedInUserLanId])

  useEffect(() => {
    if (isPol) {
      // check for session change (default every 2 seconds)
      const intervalId = setInterval(checkCookie, 2000)
      return () => {
        clearInterval(intervalId)
      }
    }
  }, [checkCookie])

  return <>{children}</>
}

const getCookieSessionJson = (cookie: any): any => {
  if (cookie) {
    const SSOSESSIONINFOcoded = window.atob(cookie)
    return JSON.parse(SSOSESSIONINFOcoded)
  }
}
